var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"m-menus"},_vm._l((_vm.menus),function(menu){return _c('a',{key:menu.value,staticClass:"u-menu",class:_vm.pathname.indexOf(menu.value) > -1 && 'is-active',attrs:{"href":`/${menu.value}`}},[_vm._v(" "+_vm._s(menu.label)+" ")])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }